import {Stub} from "../feed/components";

const DevelopersPage = () => {
    return <Stub placeholder={'DevelopersPage'} />
}

export default DevelopersPage;
